declare var ko: any;

export class PollCommercialSignals {

    public static readonly LABEL_NONE: string = "No commercial signals";
    public static readonly LABEL_SHOW: string = "Show commercial signals";
    public static readonly LABEL_HIDE: string = "Hide commercial signals";

    public static resolveSignalLabel(signalId, signalTypes): string {
        if (signalId === null || signalId === undefined || signalId === "") {
            return "";
        }

        const match = (signalTypes || []).find((type) => String(type.id) === String(signalId));

        return match ? match.label : String(signalId);
    }

    public static getParts(choice, signalTypes): Array<string> {
        const signal = ko.unwrap(choice.commercialSignal);
        const entity = (ko.unwrap(choice.commercialEntity) || "").toString().trim();
        const value = (ko.unwrap(choice.commercialValue) || "").toString().trim();

        if (!signal && !entity && !value) {
            return [];
        }

        return [this.resolveSignalLabel(signal, signalTypes), entity, value].filter((part) => part !== "");
    }

    public static format(choice, signalTypes): string {
        return this.getParts(choice, signalTypes).join(" | ");
    }

    public static hasSignals(question, signalTypes): boolean {
        return (question.choices || []).some((choice) => this.getParts(choice, signalTypes).length > 0);
    }

    /**
     * Adds the `commercialOpen` observable the question cards bind against, and
     * collapses questions that have nothing to reveal.
     */
    public static normalizeQuestions(questions, signalTypes): Array<any> {
        return (questions || []).map((question) => {
            if (!ko.isObservable(question.commercialOpen)) {
                question.commercialOpen = ko.observable(false);
            }
            if (!this.hasSignals(question, signalTypes)) {
                question.commercialOpen(false);
            }

            return question;
        });
    }

    public static toggle(question, signalTypes): void {
        if (!this.hasSignals(question, signalTypes) || !ko.isObservable(question.commercialOpen)) {
            return;
        }

        question.commercialOpen(!question.commercialOpen());
    }

    public static toggleAll(questions, signalTypes): void {
        const questionsWithSignals = (questions || []).filter((question) => this.hasSignals(question, signalTypes));
        if (!questionsWithSignals.length) {
            return;
        }

        const targetState = !this.areAllExpanded(questions, signalTypes);
        questionsWithSignals.forEach((question) => {
            if (ko.isObservable(question.commercialOpen)) {
                question.commercialOpen(targetState);
            }
        });
    }

    public static areAllExpanded(questions, signalTypes): boolean {
        return (questions || [])
            .filter((question) => this.hasSignals(question, signalTypes))
            .every((question) => ko.unwrap(question.commercialOpen));
    }

    public static getToggleLabel(question, signalTypes): string {
        if (!this.hasSignals(question, signalTypes)) {
            return this.LABEL_NONE;
        }

        return ko.unwrap(question.commercialOpen) ? this.LABEL_HIDE : this.LABEL_SHOW;
    }

    public static getToggleAllLabel(questions, signalTypes): string {
        const questionsWithSignals = (questions || []).filter((question) => this.hasSignals(question, signalTypes));
        if (!questionsWithSignals.length) {
            return this.LABEL_SHOW;
        }

        return this.areAllExpanded(questions, signalTypes) ? this.LABEL_HIDE : this.LABEL_SHOW;
    }

    public static hasAny(questions, signalTypes): boolean {
        return (questions || []).some((question) => this.hasSignals(question, signalTypes));
    }

    /**
     * A question can feed the signal generator once it has a label and something to label.
     */
    public static canGenerate(questions): boolean {
        return (questions || []).some((question) => {
            const hasText = question && question.question && String(question.question).trim() !== "";
            const hasChoices = question && question.choices && question.choices.length > 0;

            return hasText && hasChoices;
        });
    }
}



// WEBPACK FOOTER //
// ./js/utils/PollCommercialSignals.ts